/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { DimConfigurationFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type DimConfigurationsQueryVariables = Exact<{
  isActive?: boolean | null
}>

export type DimConfigurationsQuery = {
  __typename: "Query"
  dimConfigurations?: Array<{
    __typename: "DimConfiguration"
    id: string
    productName: string
    productType: string
    isActive?: boolean | null
    dimensioningKey?: string | null
  }> | null
}

export type DimConfigurationQueryVariables = Exact<{
  id: string
}>

export type DimConfigurationQuery = {
  __typename: "Query"
  dimConfiguration: {
    __typename: "DimConfiguration"
    id: string
    productName: string
    productType: string
    isActive?: boolean | null
    dimensioningKey?: string | null
  }
}

export const DimConfigurationsDocument = gql`
  query DimConfigurations($isActive: Boolean) {
    dimConfigurations(isActive: $isActive)
      @rest(
        endpoint: "dimConfiguration"
        type: "DimConfiguration"
        path: "/dimensioning-data-exchange/dim-configuration"
      ) {
      ...DimConfiguration
    }
  }
  ${DimConfigurationFragmentDoc}
`

/**
 * __useDimConfigurationsQuery__
 *
 * To run a query within a React component, call `useDimConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDimConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDimConfigurationsQuery({
 *   variables: {
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useDimConfigurationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DimConfigurationsQuery,
    DimConfigurationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    DimConfigurationsQuery,
    DimConfigurationsQueryVariables
  >(DimConfigurationsDocument, options)
}
export function useDimConfigurationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DimConfigurationsQuery,
    DimConfigurationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    DimConfigurationsQuery,
    DimConfigurationsQueryVariables
  >(DimConfigurationsDocument, options)
}
// @ts-ignore
export function useDimConfigurationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DimConfigurationsQuery,
    DimConfigurationsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  DimConfigurationsQuery,
  DimConfigurationsQueryVariables
>
export function useDimConfigurationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DimConfigurationsQuery,
        DimConfigurationsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  DimConfigurationsQuery | undefined,
  DimConfigurationsQueryVariables
>
export function useDimConfigurationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DimConfigurationsQuery,
        DimConfigurationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    DimConfigurationsQuery,
    DimConfigurationsQueryVariables
  >(DimConfigurationsDocument, options)
}
export type DimConfigurationsQueryHookResult = ReturnType<
  typeof useDimConfigurationsQuery
>
export type DimConfigurationsLazyQueryHookResult = ReturnType<
  typeof useDimConfigurationsLazyQuery
>
export type DimConfigurationsSuspenseQueryHookResult = ReturnType<
  typeof useDimConfigurationsSuspenseQuery
>
export type DimConfigurationsQueryResult = Apollo.QueryResult<
  DimConfigurationsQuery,
  DimConfigurationsQueryVariables
>
export const DimConfigurationDocument = gql`
  query DimConfiguration($id: ID!) {
    dimConfiguration(id: $id)
      @rest(
        endpoint: "dimConfiguration"
        type: "DimConfiguration"
        path: "/dimensioning-data-exchange/dim-configuration/{args.id}"
      ) {
      ...DimConfiguration
    }
  }
  ${DimConfigurationFragmentDoc}
`

/**
 * __useDimConfigurationQuery__
 *
 * To run a query within a React component, call `useDimConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDimConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDimConfigurationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDimConfigurationQuery(
  baseOptions: Apollo.QueryHookOptions<
    DimConfigurationQuery,
    DimConfigurationQueryVariables
  > &
    (
      | { variables: DimConfigurationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DimConfigurationQuery, DimConfigurationQueryVariables>(
    DimConfigurationDocument,
    options
  )
}
export function useDimConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DimConfigurationQuery,
    DimConfigurationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    DimConfigurationQuery,
    DimConfigurationQueryVariables
  >(DimConfigurationDocument, options)
}
// @ts-ignore
export function useDimConfigurationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DimConfigurationQuery,
    DimConfigurationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  DimConfigurationQuery,
  DimConfigurationQueryVariables
>
export function useDimConfigurationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DimConfigurationQuery,
        DimConfigurationQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  DimConfigurationQuery | undefined,
  DimConfigurationQueryVariables
>
export function useDimConfigurationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DimConfigurationQuery,
        DimConfigurationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    DimConfigurationQuery,
    DimConfigurationQueryVariables
  >(DimConfigurationDocument, options)
}
export type DimConfigurationQueryHookResult = ReturnType<
  typeof useDimConfigurationQuery
>
export type DimConfigurationLazyQueryHookResult = ReturnType<
  typeof useDimConfigurationLazyQuery
>
export type DimConfigurationSuspenseQueryHookResult = ReturnType<
  typeof useDimConfigurationSuspenseQuery
>
export type DimConfigurationQueryResult = Apollo.QueryResult<
  DimConfigurationQuery,
  DimConfigurationQueryVariables
>
